/*
 * OktaVerifyStepThree Messages
 *
 * This contains all the text for the OktaVerifyStepThree component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.OktaVerifyStepThree";

export default defineMessages(scope, {
  header:
    "To set up, press “ready to scan” then click “enter key manually” and enter the code below.",
  info: "*If prompted for an account name, create a memorable name and enter it in the provided field.",
  keyTextField: "Secret Key",
  nextButtonLabel: "Next",
  cancelButtonLabel: "Cancel",
});
